const themes = [
  // test theme
  {
    name: 'test',
    classNames: Array.from('123456789')
  }
]
export default themes



// WEBPACK FOOTER //
// ./src/themes.js